import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-454f1a1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" © "),
  /*#__PURE__*/_createElementVNode("strong", null, "Répertoire agroalimentaire Chaudière-Appalaches"),
  /*#__PURE__*/_createElementVNode("time", { datetime: "2022" }, " 2022"),
  /*#__PURE__*/_createTextVNode(". Portail conçu par "),
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://conceptionwm.com",
      title: "Lien vers le site de Conception WebMédia"
    }, "Conception WebMédia")
  ]),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, _hoisted_2))
}